import React, {
  FC, useCallback, useEffect, useRef, useState,
} from 'react';
import { observer } from 'mobx-react-lite';
import { getMemberIcon, IUser, useViewModel } from '@utils';
import {
  Button, FilterViewModel, Input, MeetingViewModel,
  MobileCloseButton, MobileOkButton, Search,
} from '@components';
import { MeetingPlanerViewModel } from '@views';
import { User } from '../../../user';
import '../../../../styles/views/employeesPage/employeesPage.scss';
import '../../../../styles/components/mobileMembersSelectList.scss';

interface MobileMembersSelectListProps {
  onClickMember: (memberId: number) => void;
  onClose: () => void;
}

export const MobileMembersSelectList: FC<MobileMembersSelectListProps> = observer(({ onClickMember, onClose }) => {
  const filterViewModel = useViewModel(FilterViewModel);
  const meetingViewModel = useViewModel(MeetingViewModel);
  const meetingPlanerViewModel = useViewModel(MeetingPlanerViewModel);
  const [filteredEmployee, setFilteredEmployee] = useState(filterViewModel.members);
  const [search, setSearch] = useState('');
  const ref = useRef<HTMLInputElement>();

  useEffect(() => {
    filterViewModel.onInit();
  }, []);

  useEffect(() => {
    let filtered = search.length
      ? filterViewModel.members.filter((member) => member.fullName?.toLowerCase().includes(search.toLowerCase()))
      : filterViewModel.members;

    if (filterViewModel.selectEmployeeId) {
      let filteredElem: IUser;
      filtered = filtered.filter((elem) => {
        if (elem.id === filterViewModel.selectEmployeeId) {
          filteredElem = elem;
          return false;
        }
        return true;
      });

      filtered.unshift(filteredElem);
    }

    setFilteredEmployee(filtered);
  }, [search, filterViewModel.members]);

  const onResetChoosedOptions = useCallback(
    () => {
      if (meetingViewModel.isEdit) {
        meetingViewModel.onUpdateMeeting('members', meetingViewModel.meetingData.initiator ? [meetingViewModel.meetingData.initiator] : []);
      } else {
        meetingPlanerViewModel.clearMembers();
      }
      onClose();
    },
    [],
  );

  const handleUserClick = (memberId: number) => {
    setSearch('');
    ref.current?.focus();
    onClickMember(memberId);
  };

  const findById = (id: number) => meetingViewModel.meetingData.members.find((user) => user.id === id);
  const sortingRule = (a: IUser, b: IUser) => {
    if (findById(a.id) && !findById(b.id)) {
      return -1;
    }
    if (findById(b.id) && !findById(a.id)) {
      return 1;
    }
    if (a.fullName < b.fullName) {
      return -1;
    }
    if (a.fullName > b.fullName) {
      return 1;
    }
    return 0;
  };

  return (
    <>
      <div className="employees-page">
        <Input
          filterRef={ref}
          variant="rounded"
          classes="gray search-input"
          placeholder="Поиск"
          value={search}
          onChange={setSearch}
          startIcon={<Search />}
          fastClearable
        />

        <div className="employees">
          {filteredEmployee.slice().sort(sortingRule).map((member) => (
            <User
              key={member.id}
              member={member}
              memberStatus
              isSelected={!!findById(member.id)}
              onClickMember={handleUserClick}
              memberIcon={getMemberIcon(member, false, 'work-type-icon')}
              isMobileSelect
            />
          ))}
        </div>
        <Button
          onClick={onClose}
          className="fixed-button mobile-members-list-save-button"
          icon={<MobileOkButton />}
        />
        <Button
          onClick={onResetChoosedOptions}
          className="fixed-button mobile-members-list-close-button"
          icon={<MobileCloseButton />}
        />
      </div>
    </>
  );
});
